// src/components/Projects.tsx
import React, { useState } from "react";
import "./Projects.css";
import "./Hero.css"; // ✅ Import button + line styles from Hero
import "./ButtonOverrides.css";
import { useRef } from "react";
import { Link } from "react-router-dom";
import QuickFilterDrawer, { LocFilter } from "./QuickFilterDrawer";
import { projects } from "../data/projects";

const projectCards = projects.map((p) => ({
  title: p.title,
  cover: p.cover,
  slug: p.slug,
}));

const Projects: React.FC = () => {
  const [visibleCount, setVisibleCount] = useState(9);

  const handleLoadMore = () => {
    setVisibleCount((prev) => {
      const next = prev + 9;
      return next >= projectCards.length ? projectCards.length : next;
    });
  };

  return (
  <div className="projects-section projects-page-wrapper" id="projects">
    <div className="projects-grid">
      {projectCards.slice(0, visibleCount).map((project, index) => (
        <div key={index} className="project-card">
          <Link
            to={`/projects/${project.slug}`}
            className="card-link"
          >
            {/* NOTE: no .card-thumb wrapper here, just like ProjectsPage */}
            <img
              src={project.cover}
              alt={project.title}
              loading="lazy"
            />
            <h3>{project.title}</h3>
          </Link>
        </div>
      ))}
    </div>

    {visibleCount < projectCards.length && (
      <div className="button-wrapper">
        <span className="line left-line"></span>
        <button className="hero-button" onClick={handleLoadMore}>
          LOAD MORE
        </button>
        <span className="line right-line"></span>
      </div>
    )}
  </div>
);
};



export default Projects;

